var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'inline': _vm.inline}},[(_vm.until)?_vm._t("default"):_vm._e(),_vm._v(" "),(!_vm.until)?_c('span',{staticClass:"skeleton-text"},[_vm._v("\n    skeltonskeletonskeletonskeleton\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec94cf2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeleton/skeleton-text.vue
// module id = null
// module chunks = 